import axios from 'axios';
import config from '@/config/env-constants';

export default {

    generateStencil(assetCode, id) {
        const url = `${config.cloudFunctionsBaseUrl}/generateStencilForm`;
        return axios.post(url, {
            start: assetCode,
            currUserId: id
        });
    }
}